var Marionette = require('backbone.marionette');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');

var AssignPatientForm = Marionette.View.extend({
    template: require('../../templates/documents/assign-patient-form.html'),

    regions: {
        patientSelect: '#patient-select'
    },

    ui: {
        modal: '#assign-patient-modal',
        save: '#save'
    },

    events: {
        'click @ui.save': 'onSave'
    },

    childViewEvents: {
        'suggestor:selected:patient': 'onPatientSelected'
    },

    initialize: function (options) {
        var that = this;
        that.patientId = null;
        that.utils = new CommonUtils();
        that.docIds = options.docIds;
    },

    onRender: function () {
        var that = this;
        that.show();

        that.patientsSelectView = new RemoteSuggesterView({
            maxNumberOfElements: 100,
            url: '/api/dbo/preview?page-size=' + 100
            + '&sortby=name&like_name=~~~&type=person&object_mergeable=false',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data.filter(function (item) {
                    return item.object && item.object.isPatient && item.object.mergeable === false;
                });
            },
            getValueFn: function (element) {
                return element.name;
            },
            classes: ["form-control"],
            placeholder: "Select patient to add or replace",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return (arr[index] || {}).id;
            },
            tag: 'patient'
        });

        that.showChildView('patientSelect', that.patientsSelectView);
    },

    onSave: function () {
        var that = this;
        if (that.patientId == null || that.docIds == [] || _.isEmpty(that.docIds))
            return;

        that.utils.showSpinner("#add-patient-loader");
        $.ajax({
            type: "POST",
            url: '/api/document/patient/' + that.patientId + '/multi',
            data: JSON.stringify(that.docIds),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner("#add-patient-loader");
                    that.hide();
                    $.notify({
                        message: 'Patient added to document successfully'
                    }, {
                        type: 'success',
                        z_index: 2000,
                    });
                    if (that.getOption("woResponseEvent") !== true)
                        that.triggerMethod('patient:added:to:document', {
                            documentsIdWithErrors: response
                        });
                }
            },
            error: function (e) {
                that.utils.hideSpinner("#add-patient-loader");
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    onPatientSelected: function (patientId) {
        this.patientId = patientId;
        if (_.isUndefined(patientId))
            this.ui.save.attr('disabled', true);
        else
            this.ui.save.removeAttr('disabled');
    }
});

module.exports = AssignPatientForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/assign-patient-form.js
// module id = 318
// module chunks = 0